import {useState} from 'react';
import {translations} from './data/translations';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StorySection from './components/StorySection';
import Schedule from './components/Schedule';
import Location from './components/Location';
import Dresscode from './components/Dresscode';
import Accommodation from './components/Accommodation';
import Rsvp from './components/Rsvp';
import Gifts from './components/Gifts';

export default function App() {
  const [language, setLanguage] = useState('en');
  const copy = translations[language];

  return (
    <div className="site">
      <Navbar
        copy={copy.nav}
        language={language}
        onLanguageChange={setLanguage}
      />
      <main>
        <Hero copy={copy.hero} />
        <StorySection copy={copy.story} />
        <Schedule copy={copy.schedule} />
        <Location copy={copy.location} />
        <Dresscode copy={copy.dresscode} />
        <Accommodation copy={copy.stay} />
        <Rsvp copy={copy.rsvp} formCopy={copy.rsvpForm} />
        <Gifts copy={copy.gifts} />
      </main>
      <footer className="footer">
        <span className="footer-mark">J <i>♥</i> S</span>
        <p>{copy.footer}</p>
        <span className="footer-date">{copy.hero.date}</span>
      </footer>
    </div>
  );
}